<app-layout-main [pageMetadata]="{ title: appName() }" [layoutSize]="'small'" [design]="'focused'">
	<lib-focused-card [title]="'Account confirmation'">
		@if (malformedRequest()) {
		<div>
			<lib-message [type]="'warning'">The request for confirming e-mail is malformed.</lib-message>
		</div>
		} @else { @if (emailConfirmState() === 'confirmed') {
		<lib-message [type]="'success'">Your e-mail has been successfully confirmed.</lib-message>

		<div class="push-top">
			<lib-button [routerLink]="loginRouterLink">Login</lib-button>
		</div>

		}}
	</lib-focused-card>
</app-layout-main>
